<template>
    <transition name="slide-fade">
        <div class="confirm-transfer-maai-modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full content-wrapper p-4">
                    <div class="font-semibold text-666666 text-center">{{lbl.TransferMAAI.confirm_convert}}</div>
                    <div class="text-666666 text-center pt-6">{{ lbl.TransferMAAI.Member }}: {{displayName}}</div>
                    <div class="py-6 mx-auto">
                        <div class="flex justify-center gap-12">
                            <div class="flex flex-col justify-center items-center">
                                <img class="w-80px h-80px" src="../../../../assets/logo/logo-tip.svg" alt="logo-tip">
                                <div class="font-semibold text-666666 pt-2.5">{{ FilterNumberFormat(userPoints) }}</div>
                                <div class="text-14 text-a-grey-aaaaaa">{{lbl.TransferMAAI.tip_coin}}</div>
                            </div>
                            <div class="pt-6">
                                <img class="w-5 h-8" src="../../../../assets/logo/logo-transfer.svg" alt="logo-transfer">
                            </div>
                            <div class="flex flex-col justify-center items-center">
                                <img class="w-80px h-80px rounded-20 shadow-sm" src="@/assets/logo/logo-maai-v2.png" alt="logo-maai">
                                <div class="font-semibold text-666666 pt-2.5">{{ FilterNumberFormat(transferPoints) }}</div>
                                <div class="text-14 text-a-grey-aaaaaa">{{lbl.TransferMAAI.MAAI_point}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="pb-6 text-center text-666666"> 
                        {{lbl.TransferMAAI.conversion_undone}}
                    </div>
                    <div class="">
                        <GreyBtn @click="clickOk()">{{lbl.TransferMAAI.Continue}}</GreyBtn>
                    </div>
                    <div @click="clickCancel()" class="text-center pt-6 text-tc-black-1 pb-4 cursor-pointer">
                        {{lbl.TransferMAAI.Cancel}}
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import AuthStatusMixin from "@/mixin/AuthStatusMixin";
// component
import GreyBtn from "@/components/Button/GreyBtn.vue";

export default {
    name: "ConfirmTransferMAAIModal",
    mixins: [LocaleMixin, AuthStatusMixin],
    props: {
        controller: Object,
    },
    components: {
        GreyBtn,
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            busModal: null,
            transferPoints: 0,
            userPoints: 0,
            displayName: '',
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.userPoints = config.userPoints;
            this.transferPoints = config.transferPoints;

            //console.log('profile', this.profile.displayName);
            this.displayName = this.profile?.displayName;
            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.ok;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function () {
            this.hide();
            this.controller.sendCallbackCancel();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    @import '@/style/base/base.scss';
    .confirm-transfer-maai-modal {
        @extend %modal;
        .modal-content {
            width: 500px;
            @include mobile {
                width: 366px;
            }
            .content-wrapper {
                border-radius: 40px;
            }
        }
    }

</style>
